export default __webpack_public_path__ + "static/media/15.f9e83131.mp3";